<template>
    <div class="card align-items-center justify-content-center flex flex-column">
        <h4 class="Paragraph-Medium text-center mb-6">Congratulations!</h4>
        <Timeline :value="events" align="alternate" class="custom-timeline">
            <template #marker="slotProps">
                <span class="timeline-icon flex align-items-center justify-content-center"
                    :class="slotProps.item.completed ? 'completed' : 'pending'">
                    <i :class="slotProps.item.icon"></i>
                </span>
            </template>
            <template #content="slotProps">
                <div class="timeline-content">
                    <p :class="slotProps.item.completed ? 'Paragraph-Regular' : 'text-pending'">{{
                        slotProps.item.description }}</p>
                </div>
            </template>
        </Timeline>
        <!-- <Button label="Go Home" class="teal-button mt-6" :disabled="!isVerified" @click="goToDashboard" /> -->
        <Button label="Go Home" class="teal-button mt-6" @click="goToHome" />
        <!-- <span class="Paragraph-Regular text-center mt-6">
            The Admin portal is not ready to verify tutors. <b>For testing purposes only</b>, use this button to bypass the verification process.
        </span>
        <Button label="MARK THIS PROFILE AS VERIFIED" class="mt-1" variant="outlined" severity="danger" @click="bypassVerification" /> -->
    </div>
</template>

<script setup>
import Timeline from 'primevue/timeline';
import Button from 'primevue/button';
import { ref, computed, onMounted } from "vue";
import { useAuthStore } from '@/stores/authStore';
import { useRouter } from 'vue-router';
import { getProfile } from '@/api/tutor';
import { notifyContrast } from '@/utils/notification';

// const emit = defineEmits(["bypass-verification"]);

const authStore = useAuthStore();
const router = useRouter();
const loading = ref(false);

const isVerified = computed(() =>
    // authStore.user?.verifiedByAdmins && 
    authStore.user?.registrationCompleted);

const events = ref([
    { completed: true, description: 'Your journey begins here', icon: 'pi pi-check' },
    { completed: true, description: 'Fill information & Submit all the documents', icon: 'pi pi-check' },
    { completed: true, description: 'Document verification and background check', icon: 'pi pi-check' },
    { completed: false, description: 'Congratulations! You are now verified', icon: 'pi pi-check' }
]);

onMounted(() => {
    // if (isVerified.value) {
    //     events.value[3].completed = true;
    // }
    loading.value = true;
    try {
        getProfile().then(response => {
            const freshUser = response.data.data;
            authStore.user = { ...authStore.user, ...freshUser };
            authStore.completeOnboarding();
            if (isVerified.value) {
                events.value[3].completed = true;
            }
        });
    } catch (error) {
        notifyContrast("Error", "Could not fetch your profile status. Please try refreshing the page.");
        console.error("Error fetching profile in TutorOnboardingSeventhPage:", error);
    }
    loading.value = false;
});

// const bypassVerification = () => {
//     emit("bypass-verification");
// }

// const goToDashboard = () => {
//     if (isVerified.value) {
//         router.push('/tutor_dashboard');
//     }
// }

const goToHome = () => {
    router.push('/');
}
</script>

<style scoped>
.card {
    padding: 1.5rem;
    width: 100%;
}


.custom-timeline ::v-deep(.p-timeline-event-connector) {
    background-color: var(--gray-100) !important;
}

.custom-timeline ::v-deep(.p-timeline-vertical .p-timeline-event-connector) {
    width: 2px;
    background: var(--gray-100);
}


.timeline-icon {
    border-radius: 50%;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid;
}

.timeline-icon i {
    font-size: 0.8rem;
}

.timeline-icon.pending {
    background-color: #ffffff;
    border-color: var(--gray-100);
    color: var(--gray-100);
}

.timeline-icon.completed {
    background-color: white;
    border-color: #10b981;
    color: #10b981;
}

.text-pending {
    color: var(--gray-100);
}

.timeline-content {
    padding: 0 1rem;
}

@media screen and (max-width: 768px) {
    .card {
        padding: 1rem;
        width: auto;
    }

    .custom-timeline ::v-deep(.p-timeline-event) {
        align-items: flex-start;
        min-height: auto;
    }

    .custom-timeline ::v-deep(.p-timeline-event-content) {
        width: 100%;
        margin-top: 0.75rem;
    }

    .timeline-content {
        padding: 0;
    }



}
</style>